import {FC} from "react";
import {useOrganizationsAndParticipantsContext} from "../../providers/OrganizationsAndParticipantsProvider";

export const AdminParticipantsSearchInput: FC = () => {

  const {setNameFilter} = useOrganizationsAndParticipantsContext()

  return (
    <div className="relative justify-center md:w-full">
      <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
        <svg className="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
             fill="none" viewBox="0 0 20 20">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
        </svg>
      </div>
      <input type="search"
             onChange={(e) => setNameFilter(e.target.value)}
             className="block w-[300px] p-2 ps-10 text-gray-900 border border-gray-300 rounded-md"
             placeholder="Hledejte podle jména..."/>
    </div>
  )
}